import jwtDecode from 'jwt-decode'

import { getTokens } from 'core/classes/helpers/StorageHelper'

interface IDataJWT {
  unique_name: string
  email: string
  given_name: string
  family_name: string
  app_id: string
  simulation_mode: string
  simulation_owner: string
  partner_id: string
  exp: number
}

class _PartnerIdTokenHelper {
  private partnerId: string = ''
  public initializePartnerId = async (ownerId: string) => {
    try {
      const result = await getTokens(ownerId)
      const token = result && result[0] != null ? result[0] : ''
      if (token) {
        const data = jwtDecode<IDataJWT>(token)
        if (data && data.partner_id) {
          this.partnerId = data.partner_id
        }
      }
      return null
    } catch (e) {
      return null
    }
  }
  public getPartnerId = () => {
    return this.partnerId
  }
}

export const PartnerIdTokenHelper = new _PartnerIdTokenHelper()
